/** Jours de la semaine (ticket COMPETENCE : jours travaillés). Miroir de l'enum back. */
export enum WeekDayEnum {
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
  SUNDAY = 'SUNDAY',
}

export const weekDayOptions: { value: WeekDayEnum; label: string }[] = [
  { value: WeekDayEnum.MONDAY, label: 'Lun' },
  { value: WeekDayEnum.TUESDAY, label: 'Mar' },
  { value: WeekDayEnum.WEDNESDAY, label: 'Mer' },
  { value: WeekDayEnum.THURSDAY, label: 'Jeu' },
  { value: WeekDayEnum.FRIDAY, label: 'Ven' },
  { value: WeekDayEnum.SATURDAY, label: 'Sam' },
  { value: WeekDayEnum.SUNDAY, label: 'Dim' },
];

/** Repli pour les tickets COMPETENCE créés avant PRED-3286 (pas de jours travaillés saisis). */
export const DEFAULT_WORKED_DAYS: WeekDayEnum[] = [
  WeekDayEnum.MONDAY,
  WeekDayEnum.TUESDAY,
  WeekDayEnum.WEDNESDAY,
  WeekDayEnum.THURSDAY,
  WeekDayEnum.FRIDAY,
];

/** « Lun, Mar, Mer » dans l'ordre de la semaine, quel que soit l'ordre de sélection. */
export const weekDaysLabel = (days: WeekDayEnum[] | undefined): string =>
  weekDayOptions
    .filter(option => days?.includes(option.value))
    .map(option => option.label)
    .join(', ');
